<template>
    <div style="padding: 20px;" class="orderList">
        <Table :columns="columns12" height="500" :highlight-row="true" :stripe="true" :data="orderList" @on-row-click="toInfo">
            <template slot-scope="{ row }" slot="title">
                <strong>{{ row.userNames }}</strong>
            </template>
            <template slot-scope="{ row }" slot="positionName">
                <strong>{{ row.position }}</strong>
            </template>
            <template slot-scope="{ row }" slot="bookYear">
                {{ row.year }}年{{row.month}}月
            </template>
            <template slot-scope="{ row }" slot="statusName">
                <strong :style="{color:checkCls(row.status)}">{{ row.statusName }}</strong>
            </template>
        </Table>
    </div>
</template>

<script>
    var self;
    import api from '../../api/api'
    export default {
        components: {

        },
        data(){
            return{
                columns12: [
                    // {
                    //     title: '联系人姓名',
                    //     key: 'linkmanName',
                    // },
                    {
                        title: '逝者姓名',
                        slot: 'title',
                        key: 'userNames',
                    },
                    {
                        title: '预约地点',
                        slot: 'positionName',
                        key: 'positionName',
                    },
                    {
                        title: '预约年限',
                        slot: 'bookYear',
                        key: 'bookYear',
                    },
                    {
                        title: '预约状态',
                        slot: 'statusName',
                        key: 'statusName',
                    },
                ],
                orderList:[],
                pageInfo:{
                    page:0,
                    pageSize:100
                }
            }
        },
        computed:{

        },
        activated(){
            self = this;
            this.getOrderList()
        },
        methods:{
            checkCls(id){
                var color = '';
                switch(id){
                    case '1':color='#009DE9';break;
                    default: color='#333'
                }
                return color
            },
            getOrderList(){
                api.orderList().then(res => {
                    if (res == null) return
                    self.orderList = res.rows;
                })
            },
            toInfo (item) {
                this.$router.push({name:'orderInfo',params:{id:item.id}})
                // this.$emit('toInfo',item.indexId)
            }
        }
    }
</script>

<style scoped lang="scss">

    .orderList {
        .ivu-table .ivu-table-row :hover {
            cursor: pointer!important;
        }
    }

</style>
